import { render, staticRenderFns } from "./messages-per-channel.vue?vue&type=template&id=2e35cefa&scoped=true&"
import script from "./messages-per-channel.vue?vue&type=script&lang=js&"
export * from "./messages-per-channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e35cefa",
  null
  
)

export default component.exports